export enum Color {
  Gray0 = '#F8F9FA',
  Gray1 = '#F1F3F4',
  Gray2 = '#E9ECEE',
  Gray3 = '#DEE2E5',
  Gray4 = '#CDD3D8',
  Gray5 = '#ACB4BB',
  Gray6 = '#868D94',
  Gray7 = '#495056',
  Gray8 = '#343A3E',
  Gray9 = '#212528',
  Green = '#4FCC53',
  YellowL = '#FCD03D',
  YellowM = '#F9A91B',
  YellowD = '#F78725',
  Red = '#E63740',
  Blue = '#64C2E6'
}
